import React, { useState, useRef, useEffect } from 'react';
import '../styles/Header.css';
const Header = ({ user, queriesLeft, isAdmin, onLogout, onOpenUserManagement, onOpenTracker, onOpenSkills, showSkills, onLogoClick }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };
    if (showProfileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showProfileMenu]);
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left" onClick={onLogoClick} style={{ cursor: 'pointer' }} title="Go to Dashboard">
          {/* Logo - Try to load, fallback to emoji */}
          <img
            src="/logo.png"
            alt="VBL Logo"
            className="company-logo"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="company-logo-fallback" style={{ display: 'none' }}>
            <span className="logo-emoji">🤖</span>
          </div>
          <div className="header-title">
            <h1>Sales AI Agent</h1>
            <span className="header-subtitle">VBL Analytics</span>
          </div>
        </div>
        <div className="header-right">
          {isAdmin && (
            <button
              className="header-user-management-btn"
              onClick={onOpenUserManagement}
              title="User Management"
            >
              <span className="management-icon">👥</span>
              <span className="management-text">User Management</span>
            </button>
          )}

          {/* ── NEW: Email Tracker button ── */}
          <button
            className="header-user-management-btn"
            onClick={onOpenTracker}
            title="Email Tracker"
          >
            <span className="management-icon">📧</span>
            <span className="management-text">Tracker</span>
          </button>

          {/* ── SKILLS: Skills Manager button (only if user has skill_access) ── */}
          {showSkills && (
            <button
              className="header-user-management-btn"
              onClick={onOpenSkills}
              title="Manage Skills"
            >
              <span className="management-icon">⚡</span>
              <span className="management-text">Skills</span>
            </button>
          )}

          <div className="header-queries-left">
            <span className="queries-icon">📊</span>
            <div className="queries-info">
              <span className="queries-count">{queriesLeft}</span>
              <span className="queries-label">QUERIES LEFT</span>
            </div>
          </div>
          <div className="header-profile-container" ref={profileMenuRef}>
            <button
              className="header-profile-btn"
              onClick={() => setShowProfileMenu(!showProfileMenu)}
              title={user?.username || 'Profile'}
            >
              <div className="profile-avatar">
                {user?.username?.charAt(0).toUpperCase() || '👤'}
              </div>
              <span className="profile-name">{user?.username}</span>
              <span className="profile-dropdown-arrow">{showProfileMenu ? '▲' : '▼'}</span>
            </button>
            {showProfileMenu && (
              <div className="header-profile-dropdown">
                <div className="dropdown-user-info">
                  <div className="dropdown-avatar">
                    {user?.username?.charAt(0).toUpperCase() || '👤'}
                  </div>
                  <div className="dropdown-details">
                    <span className="dropdown-username">{user?.username || 'User'}</span>
                    <span className="dropdown-email">{user?.email || user?.username}</span>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item logout-item" onClick={onLogout}>
                  <span className="dropdown-icon">🚪</span>
                  <span className="dropdown-text">Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
